"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Log_1 = require("../../../../Log");

var Links_1 = require("../utils/Links");

var AbstractVideoEmbedder_1 = require("./AbstractVideoEmbedder");

var TwitchEmbedder =
/*#__PURE__*/
function (_AbstractVideoEmbedde) {
  _inherits(TwitchEmbedder, _AbstractVideoEmbedde);

  function TwitchEmbedder() {
    _classCallCheck(this, TwitchEmbedder);

    return _possibleConstructorReturn(this, _getPrototypeOf(TwitchEmbedder).apply(this, arguments));
  }

  _createClass(TwitchEmbedder, [{
    key: "markEmbedIfFound",
    value: function markEmbedIfFound(child) {
      try {
        var data = child.data;
        var twitch = this.twitchId(data);

        if (!twitch) {
          return undefined;
        }

        var embedMarker = AbstractVideoEmbedder_1.AbstractVideoEmbedder.getEmbedMarker(twitch.id, TwitchEmbedder.TYPE);
        child.data = data.replace(twitch.url, embedMarker);
        return {
          link: twitch.canonical
        };
      } catch (error) {
        Log_1.Log.log().error(error);
      }

      return undefined;
    }
  }, {
    key: "processEmbedIfRelevant",
    value: function processEmbedIfRelevant(embedType, id, size, htmlElementKey) {
      if (embedType !== TwitchEmbedder.TYPE) return undefined;
      var url = "https://player.twitch.tv/".concat(id);
      return "<div className=\"videoWrapper\">\n                <iframe\n                    key=".concat(htmlElementKey, "\n                    src=").concat(url, "\n                    width=").concat(size.width, "\n                    height=").concat(size.height, "\n                    rameBorder=\"0\"\n                    allowFullScreen\n                />\n            </div>");
    }
  }, {
    key: "twitchId",
    value: function twitchId(data) {
      if (!data) {
        return null;
      }

      var m = data.match(Links_1.default.twitch);

      if (!m || m.length < 3) {
        return null;
      }

      return {
        id: m[1] === "videos" ? "?video=".concat(m[2]) : "?channel=".concat(m[2]),
        url: m[0],
        canonical: m[1] === "videos" ? "https://player.twitch.tv/?video=".concat(m[2]) : "https://player.twitch.tv/?channel=".concat(m[2])
      };
    }
  }]);

  return TwitchEmbedder;
}(AbstractVideoEmbedder_1.AbstractVideoEmbedder);

TwitchEmbedder.TYPE = "twitch";
exports.TwitchEmbedder = TwitchEmbedder;